import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { PAGE_LOGIN } from "../locales/pages/namespaces";
import useUserData from "./user/useUserData";
import { enqueueSnackbar } from "notistack";
import { handleAxiosErrors } from "../helpers/errorHandling";
import { API } from "../helpers/constants";

const useProductData = ({ filters, sorting, page }) => {
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState(null);
    const [error, setError] = useState(null);
    const { token } = useUserData();
    const { t } = useTranslation(PAGE_LOGIN);

    const requestFilters = useMemo(() => {
        const hasMin =
            typeof filters?.priceMin === "number" && !Number.isNaN(filters.priceMin);
        const hasMax =
            typeof filters?.priceMax === "number" && !Number.isNaN(filters.priceMax);

        return {
            categories: filters?.categories?.join(",") ?? "",
            brands: filters?.brands?.join(",") ?? "",
            colors: filters?.colors?.join(",") ?? "",
            products: filters?.products?.join(",") ?? "",
            min: hasMin ? filters.priceMin : "",
            max: hasMax ? filters.priceMax : "",
            sorting: sorting ?? "",
            page: page ?? 1,
        };
    }, [filters, sorting, page]);

    const filtersKey = useMemo(
        () => JSON.stringify(requestFilters),
        [requestFilters]
    );

    useEffect(() => {
        setLoading(true);
        setError(null);

        const payload = {
            filters: requestFilters
        };

        axios({
            method: "post",
            url: `${API}/en/brew/item/index`,
            headers: {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            data: payload,
        })
            .then((res) => {
                setProducts(res.data);
                setLoading(false);
            })
            .catch((err) => {
                setError(err);
                setLoading(false);

                enqueueSnackbar(
                    handleAxiosErrors(err, t("An error occurred!")),
                    {
                        variant: "error",
                        autoHideDuration: 3000,
                    }
                );
            });
    }, [token, filtersKey, sorting, page, t]);

    return {
        loading,
        products,
        error,
    };
};

export default useProductData;